<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>账户安全</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-tabs v-model="activeName">
            <el-tab-pane label="修改密码" name="updatePass"></el-tab-pane>
            <el-tab-pane label="修改账号" name="updatePhoneNo"></el-tab-pane>
        </el-tabs>
        <div v-if="activeName == 'updatePass'">
            <el-form :model="userInfo" :rules="userRules" ref="userInfo" class="demo-ruleForm">
                <div class="simple-form">
                    <div class="form-group center">
                        <div class="form-label">
                            <label class="required">旧密码</label>
                        </div>
                        <div class="form-value width-1-5x">
                            <el-form-item prop="passwordOld">
                                <el-input type="password" v-model="userInfo.passwordOld" auto-complete="off"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label class="required">新密码</label>
                        </div>
                        <div class="form-value width-1-5x">
                            <el-form-item prop="password">
                                <el-input type="password" v-model="userInfo.password" auto-complete="off"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label class="required">重复密码</label>
                        </div>
                        <div class="form-value width-1-5x">
                            <el-form-item prop="passwordRep">
                                <el-input type="password" v-model="userInfo.passwordRep" auto-complete="off"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div class="form-toolbar">
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('userInfo')">提交</el-button>
                        <el-button @click="resetForm('userInfo')">重置</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>

        <div v-if="activeName == 'updatePhoneNo'">
            <el-form :model="updateUserPhone" :rules="updateUserPhoneRules" ref="updateUserPhone" class="demo-ruleForm">
                <div class="simple-form">
                    <div class="form-group center">
                        <div class="form-label">
                            <label class="required">原手机号</label>
                        </div>
                        <div class="form-value width-1-5x">
                            <el-form-item prop="oldPhoneNo">
                                <el-input type="text" v-model="updateUserPhone.oldPhoneNo"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label class="required">密码</label>
                        </div>
                        <div class="form-value width-1-5x">
                            <el-form-item prop="oldPassword">
                                <el-input type="password" v-model="updateUserPhone.oldPassword"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-group center" style="height: 50px;">
                        <div class="form-label">
                            <label class="required">新手机号</label>
                        </div>
                        <div class="form-value width-1-5x">
                            <el-form-item prop="newPhoneNo">
                                <el-input type="text" v-model="updateUserPhone.newPhoneNo"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-group center" v-if="isOutlandMobileNo">
                        <div class="form-label">
                            <label class="required">绑定邮箱</label>
                        </div>
                        <div class="form-value width-1-5x">
                            <el-form-item prop="smsEmail">
                                <el-input type="text" v-model="updateUserPhone.smsEmail"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label class="required">验证码</label>
                        </div>
                        <div class="form-value"  style="width: 240px">
                            <label class="sms-btn" v-if="!btnlock" @click="sendSmsForRegist()">获取验证码</label>
                            <label class="sms-btn active" v-else >( {{nums}} ) 秒后获取</label>
                            <el-form-item prop="smsCode">
                                <input style="width: 240px" class="sms" type="text" v-model="updateUserPhone.smsCode" placeholder="请输入手机验证码"/>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <!--<div class="form-group center">-->
                <!--<div class="form-label">-->
                <!--<label class="required">验证码</label>-->
                <!--</div>-->
                <!--<div class="form-value width-1-5x">-->
                <!--<el-form-item prop="smsCode">-->
                <!--<el-input type="text" v-model="updateUserPhone.smsCode"></el-input>-->
                <!--</el-form-item>-->
                <!--<button class="swb-btn swb-btn-mini" v-if="!btnlock" :class="btnClass" @click="sendSmsForRegist()">获取验证码</button>-->
                <!--<label v-else :class="btnClass">( {{nums}} ) 秒后获取</label>-->
                <!--</div>-->
                <!--</div>-->
                <div class="form-toolbar">
                    <el-form-item>
                        <el-button type="primary" @click="submitChangePhoneNo('updateUserPhone')">提交</el-button>
                        <el-button @click="resetChangePhoneNo('updateUserPhone')">重置</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import notifyApi from '../../api/notify'
    import userApi from '../../api/user'

    export default {
        name: 'swb-pass-word-update',
        path: '/personal/pswd/modify',
        pathOld: '/password/info',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        desc: '账号安全',
        data: function () {
            let self = this;
            let checkPasswordOld = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请输入旧密码'));
                } else {
                    callback();
                }
            };
            let checkPassword = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请输入新密码'));
                } else {
                    if(self.userInfo.passwordRep !== '') {
                        self.$refs.userInfo.validateField('passwordRep');
                    }
                    callback();
                }
            };
            let checkPasswordRep = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    return callback(new Error('请输入重复密码'));
                } else if(value !== self.userInfo.password) {
                    callback(new Error('重复密码要与新密码一致!'));
                } else {
                    callback();
                }
            };
            let checkNull = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    return callback(new Error('不可为空！'));
                } else {
                    callback();
                }
            };
            let checkEmail = function (rule, value, callback) {
                if(self.isOutlandMobileNo) {//海外手机号
                    if(!Utils.isEmail(value)) {
                        callback(new Error('请输入有效的绑定邮箱!'));
                    }
                }
                callback();
            };
            let chageNewPhoneNo = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    self.isOutlandMobileNo = false;
                    return callback(new Error('新手机号不能为空'));
                } else {
                    if(!Utils.isMobileNo(value)) {
                        self.isOutlandMobileNo = false;
                        return callback(new Error('新手机号码无效'));
                    } else {
                        if(!Utils.isInlandMobileNo(value)) {
                            self.isOutlandMobileNo = true;
                        } else {
                            self.isOutlandMobileNo = false;
                        }
                        callback();
                    }
                }
            };
            return {
                userInfo: {
                    passwordOld: '',
                    password: '',
                    passwordRep: ''
                },
                userRules: {
                    passwordOld: [{
                        validator: checkPasswordOld,
                        trigger: 'blur'
                    }],
                    password: [{
                        validator: checkPassword,
                        trigger: 'blur'
                    }],
                    passwordRep: [{
                        validator: checkPasswordRep,
                        trigger: 'blur'
                    }]
                },
                //
                activeName: 'updatePass',
                isOutlandMobileNo: false,//是否海外手机号
                btnlock: false,
                nums: 60,
                updateUserPhone: {
                    oldPhoneNo: null,
                    oldPassword: null,
                    newPhoneNo: null,
                    smsCode: null,
                    smsEmail: null
                },
                updateUserPhoneRules: {
                    oldPhoneNo: [{
                        validator: checkNull,
                        trigger: 'blur'
                    }],
                    oldPassword: [{
                        validator: checkNull,
                        trigger: 'blur'
                    }],
                    newPhoneNo: [{
                        validator: chageNewPhoneNo,
                        trigger: 'blur'
                    }],
                    smsCode: [{
                        validator: checkNull,
                        trigger: 'blur'
                    }],
                    smsEmail: [{
                        validator: checkEmail,
                        trigger: 'blur'
                    }],

                }
            }
        },
        created: function () {
            //
            this.getCurrentUserInfo();
        },
        methods: {
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserByContext({}, function (result, jqXhr) {
                    if(result.type == 'info') {
                        let userInfo = result.data;
                        //
                        self.updateUserPhone.smsEmail = userInfo.email || null;
                        self.updateUserPhone.oldPhoneNo = userInfo.phoneNo;
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            // =================================== 修改密码 ===================================
            submitForm(formName) {
                let self = this;
                self.$refs[formName].validate(function (valid) {
                    if(valid) {
                        let postData = self.userInfo;
                        userApi.updateUserPswdByContext(postData, function (result, jqXhr) {
                            if(result.type == "info") {
                                self.resetForm(formName);
                                MsgBox.success("修改成功");
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },
            // 重置
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },

            // =================================== 修改账号 ===================================
            // 注册发送验证码
            sendSmsForRegist: function () {
                let self = this;
                // 添加js定时器
                self.btnClass = 'group-laber sms checked';
                self.btnlock = true;
                self.clock = setInterval(self.doLoop, 1000); //一秒执行一次
                //
                let postData = {};
                postData.phoneNo = self.updateUserPhone.newPhoneNo;
                if(self.isOutlandMobileNo) {
                    if(Utils.isNoB(self.updateUserPhone.smsEmail)) {
                        MsgBox.warning("请输入邮箱地址！");
                        // 清除js定时器
                        self.clearInterval();
                        return;
                    }
                    postData.smsEmail = self.updateUserPhone.smsEmail;
                }
                notifyApi.sendSmsForRegist(postData, function (result) {
                    if(result.type == 'info') {
                        if(result.data != null) {
                            //
                            MsgBox.info(result.data);
                        } else {
                            MsgBox.success(result.message);
                        }
                    } else {
                        // 清除js定时器
                        self.clearInterval();
                        MsgBox.warning(result.message);
                    }
                });
            },
            doLoop: function () {
                this.nums--;
                if(this.nums < 0) {
                    this.clearInterval();
                }
            },
            clearInterval: function () {
                clearInterval(this.clock); //清除js定时器
                this.btnlock = false;
                this.nums = 60; //重置时间
                this.btnClass = 'group-laber sms';
            },
            //
            submitChangePhoneNo(formName) {
                let self = this;
                self.$refs[formName].validate(function (valid) {
                    if(valid) {
                        let updateUserPhone = self.updateUserPhone;
                        if(self.isOutlandMobileNo) {
                            if(Utils.isNoB(updateUserPhone.smsEmail)) {
                                MsgBox.warning("请输入邮箱！");
                                return;
                            }
                        } else {
                            updateUserPhone.smsEmail = null;
                        }
                        let theLoad = MsgBox.loading();
                        userApi.changeUserPhoneNo(updateUserPhone, function (result, jqXhr) {
                            theLoad.hide();
                            if(result.type == "info") {
                                self.resetForm(formName);
                                self.getCurrentUserInfo();
                                // 清除js定时器
                                self.clearInterval();
                                //
                                MsgBox.success("修改成功");
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },
            resetChangePhoneNo(formName) {
                this.$refs[formName].resetFields();
            },
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/user/PassWordUpdate.vue